import { IOrderManagementFilterBody, IOrderManagementStatsFilterBody } from "@/api_framework/api_modals/Orders";
import { useOrderManagementOrderListAPI } from "@/app/hooks/api_hooks/orders/useOrderListAPI";
import { useOrderManagementOrderUpdateAPI } from "@/app/hooks/api_hooks/orders/useOrderManagementActionAPI";
import { useOrderManagementStatsAPI } from "@/app/hooks/api_hooks/orders/useOrderStatsAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import {
  IOrderManagementState,
  setIsUserPopupModalActive,
} from "@/app_redux/reducers/slices/auth/order_management_slice";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

export interface IRotaFiltersFormFields {
  name?: string;
  cancelreason?: string;
  cancel_reason_name?: string;
}
export interface ActionBodyForProps {
  sub_order_id?: string;
  internal_order_status?: string;
  cancel_reason?: any;
}

export default function AcceptReturnConfirmation({
  setIsConFirmationOpen,
  setOpen,
  isConFirmationOpen,
  payloadData,
  orders,
}) {
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);
  const dispatch = useDispatch();
  const { orderFilter, orderModule } = routeState.state as IOrderManagementState;

  const { execute: updateOrdersAPI } = useOrderManagementOrderUpdateAPI();
  const fetchOrderListAPI = useOrderManagementOrderListAPI();
  const fetchStatsAPI = useOrderManagementStatsAPI();
  const [totalActualQnt, setTotalActualQnt] = useState(0);
  const [totalReciveQnt, setTotalReciveQnt] = useState(0);

  useEffect(() => {
    if (isConFirmationOpen) {
      dispatch(setIsUserPopupModalActive(true));
    } else {
      dispatch(setIsUserPopupModalActive(false));
    }
  }, [isConFirmationOpen]);

  const cancelButtonRef = useRef(null);

  useEffect(() => {
    if (payloadData?.returned_items?.length > 0 && orders?.sub_order_items?.length > 0) {
      const totalActualQuantity = orders?.sub_order_items?.reduce((sum, item) => sum + item.quantity_to_pick, 0);
      const totalReceivedQuantity = payloadData?.returned_items?.reduce((sum, item) => sum + item.quantity_to_pick, 0);
      setTotalActualQnt(totalActualQuantity);
      setTotalReciveQnt(totalReceivedQuantity);
    }
  }, [payloadData, orders]);

  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  // ✅ read query params
  const queryClinics = queryParams.get("clinic_ids");
  const queryShift = queryParams.get("shift") ?? "day";
  const processId = queryParams.get("closing_process");
  const city_id = queryParams.get("city_id");
  const isClinicView = queryParams.get("is_clinic");

  console.log(orderModule);

  const handelSubmit = () => {
    const statsBody: IOrderManagementStatsFilterBody = {
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      clinic_id: orderFilter?.clinic_id?.split(","),
    };
    const requestBody: IOrderManagementFilterBody = {
      clinic_id: orderFilter?.clinic_id?.split(","),
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      order_status: "",
      source: orderModule,
      // ...(orderSource && { order_source: orderSource }),
      // page_number: page,
      // page_size: 20,
      // ...(isCentralRole && { for_central: "true" }),
    };
    updateOrdersAPI(payloadData as any).then(({ status }) => {
      if (status) {
        (fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody));
        setIsConFirmationOpen(false);
        setOpen(false);
        processId &&
          navigate(
            `/app/closing/day-closing?closing_process=${processId}&city_id=${city_id}&clinic_ids=${queryClinics}&is_clinic=${isClinicView}&shift=${queryShift}&t=${Date.now()}`,
          );
      }
    });
  };

  return (
    <div>
      <Transition.Root show={isConFirmationOpen} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={setIsConFirmationOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-4 
              
                sm:max-w-2xl
                sm:w-full  sm:p-6`}
                >
                  <p className="text-sm">
                    Are you sure you want to accept only {totalReciveQnt} / {totalActualQnt} returned items of the
                    order?
                  </p>
                  <div className=" flex justify-between p-4 gap-4 mt-4">
                    <div className="flex justify-end w-full gap-3">
                      <button
                        className="rounded-md bg-opacity-10 bg-gray-500 py-2 w-1/5 text-black font-medium"
                        onClick={() => setIsConFirmationOpen(false)}
                      >
                        No
                      </button>
                      <button
                        onClick={() => handelSubmit()}
                        className="rounded-md bg-[#193A6A] text-center w-1/5 font-medium cursor-pointer text-white shadow-sm text-sm"
                      >
                        {" "}
                        Yes
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
